import PropTypes from 'prop-types';
import React, { useState } from 'react';
import LoginAPI from '../../../../services/API/others/LoginAPI';
import { verifyEmail } from '../../../../services/auxiliaryFunctions/functions';
import {
  ButtonStyled,
  ButtonTextStyled,
  Link2Styled,
  TitleStyled,
} from '../../../pages/others/login/login.styles';
import ToasterBox from '../../singleComponents/toaster/ToasterBox';
import {
  Container,
  Input2Styled,
  LinkContainerStyled,
  SubtitleStyled,
} from './accountRetrieve.styles';

export default function AccountRetrieve(props) {
  const { setIsAccountRetrieve } = props;
  const [email, setEmail] = useState('');
  const [toasterShow, setToasterShow] = useState(false);
  const [messageNumber, setMessageNumber] = useState(1);

  const alertMessage = (numberMessage) => {
    let message = '';
    switch (numberMessage) {
      case 1:
        message =
          'Em breve as instruções serão enviadas para o e-mail indicado';
        break;
      case 2:
        message = 'Ocorreu um erro, tente novamente em alguns segundos.';
        break;
      case 3:
        message = 'Ops, este é um e-mail inválido!';
        break;
      case 4:
        message = 'Email não pertence a um usuário';
        break;
      default:
        break;
    }
    return message;
  };

  const handleSubmitEmail = () => {
    if (verifyEmail(email)) {
      LoginAPI.postLoginResetPasswordNoAuth({ email })
        .then(({ data }) => {
          setMessageNumber(data.status === -1 ? 4 : 1);
          setToasterShow(true);
        })
        .catch((error) => {
          setMessageNumber(2);
          setToasterShow(true);
          console.error(error);
        })
        .finally(setEmail(''));
    } else {
      setMessageNumber(3);
      setToasterShow(true);
    }
  };

  return (
    <Container>
      {toasterShow && <ToasterBox message={alertMessage(messageNumber)} />}
      <TitleStyled variant="h1">Recuperar senha</TitleStyled>
      <SubtitleStyled variant="h3">
        Para recuperar sua senha, basta digitar o e-mail de cadastro que
        enviaremos as instruções
      </SubtitleStyled>
      <Input2Styled
        fullWidth
        placeholder="E-mail"
        value={email}
        onChange={({ target }) => {
          setToasterShow(false);
          setEmail(target.value);
        }}
      >
        {' '}
      </Input2Styled>
      <ButtonStyled fullWidth onClick={handleSubmitEmail} disabled={!email}>
        <ButtonTextStyled variant="h3">
          Enviar instruções no e-mail
        </ButtonTextStyled>
      </ButtonStyled>
      <LinkContainerStyled>
        <Link2Styled
          variant="caption"
          onClick={() => setIsAccountRetrieve(false)}
          style={{ fontSize: '14px' }}
        >
          voltar
        </Link2Styled>
      </LinkContainerStyled>
    </Container>
  );
}

AccountRetrieve.propTypes = {
  setIsAccountRetrieve: PropTypes.func.isRequired,
};
